<template>
    <div ref="parent" class="form-panel v--20">
        <!-- {{instance}} -->

        <div v-if="instance.title || instance.content" class="form-panel__top v--15">
            <h2 v-if="instance.title" class="form-panel__title type--h2" v-html="parseText(instance.title)"></h2>
            <div v-if="instance.content" class="form-panel__content type--content-links type--content-margins type--content-styles" v-html="instance.content"></div>
        </div>

        <!-- instance image is not in here yet -->
        <div v-if="instance.image !== 0" class="text__content__image"></div>
        
        <form 
            ref="form"
            action="" 
            method="post" 
            :data-type="type" 
            :data-on-submit-url="on_submit_url" 
            class="form form--v required v--50">

            <div class="form__fields r v--20">
                <!-- have to loop through fields here, will probably do components-->
                <div v-for="(field, index) in instance.form.widgets" :key="field._sow_form_id">
                    <Buttons v-if="field.panels_info.class === 'Form_Buttons'" :field="field" :siloData="siloData" @validate="validate"/>
                    <CheckBoxes v-if="field.panels_info.class === 'Form_Checkboxes'" :field="field" :siloData="siloData" @validate="validate"/>
                    <TextField v-if="field.panels_info.class === 'Field_Text'" :field="field" :siloData="siloData" @validate="validate"/>
                    <TextAreaField v-if="field.panels_info.class === 'Field_Textarea'" :field="field" :siloData="siloData" @validate="validate"/>
                    <Likert v-if="field.panels_info.class === 'Form_Likert'" :field="field" :siloData="siloData" @validate="validate"/>
                    <FormDecisions v-if="field.panels_info.class === 'Form_Decisions'" :field="field" :siloData="siloData" @validate="validate"/>
                    <FormGoals v-if="field.panels_info.class === 'Form_Goals'" :field="field" :siloData="siloData" @validate="validate"/>
                    <PanelText v-if="field.panels_info.class === 'Text_Panel'" :instance="field" :siloData="siloData" :active="text_is_active_hack"/>
                    <PanelVariable v-if="field.panels_info.class === 'Variable_Panel'" :instance="field" :siloData="siloData"/>

                    <PanelEmbed v-if="field.panels_info.class === 'Embed_Panel'" :instance="field" :active="active" :pauseVideo="pauseVideo" v-bind:allowNext="false" @next="" @playingVideo="playingVideo" @close="" @validate="validate"/>

                </div>
            </div>
            <div v-for="(field, index) in instance.hidden_fields" :key="index">
                <input 
                    type="hidden"
                    :name="field.key"
                    :data-push-key="field.key"
                    :data-meta-key="field.key"
                    :value="field.value"
                    required>
            </div>
            <div v-if="instance.post_form_content" class="form__pfc r type--content-styles type--content-margins" v-html="instance.post_form_content"></div>
            <div class="form__footer r r--justify-center r--halign-center v--30 type--align-center">
                <transition name="button">
                    <template v-if="!isLast">
                        <button
                            :disabled="!is_valid"
                            class="ms__next form__submit btn btn--solid"
                            @click.prevent="submit"
                            v-html="instance.button_text ? filterNextButtonText(instance.button_text) : 'Next'">
                        </button>
                    </template>
                    <template v-else>
                        <button
                            :disabled="!is_valid"
                            class="ms__home form__submit btn btn--solid"
                            @click.prevent="submit"
                            >Finish
                        </button>
                    </template>
                </transition>
            </div>
        </form>
    </div>
</template>

<script>
import Buttons from "@c/panels/form/Buttons.vue";
import CheckBoxes from "@c/panels/form/CheckBoxes.vue";
import TextField from "@c/panels/form/TextField.vue";
import TextAreaField from "@c/panels/form/TextAreaField.vue";
import Likert from "@c/panels/form/Likert.vue";
import FormDecisions from "@c/panels/form/FormDecisions.vue";
import PanelText from "@c/panels/PanelText.vue";
import PanelVariable from "@c/panels/PanelVariable.vue";
import PanelEmbed from "@c/panels/PanelEmbed.vue";
import FormGoals from "@c/panels/form/FormGoals.vue";

const pristine = require("pristinejs");
const axios = require('axios');

export default {
    components: {
        Buttons,
        CheckBoxes,
        TextField,
        TextAreaField,
        Likert,
        PanelText,
        PanelVariable,
        FormDecisions,
        PanelEmbed,
        FormGoals,
    },
    data() {
        return {
            pristine: null,
            validation_config: {
                // class of the parent element where the error/success class is added
                classTo: 'input',
                errorClass: 'input--error',
                successClass: 'input--success',
                // class of the parent element where error text element is appended
                errorTextParent: 'input',
                // type of element to create for the error text
                errorTextTag: 'div',
                // class of the error text element
                errorTextClass: 'input__help'
            },
            type: this.instance.type,
            on_submit_url: this.instance.on_submit_url,
            inputs: null,
            is_valid: false, // may want to make this mor ambiguous at some point
            text_is_active_hack: true,
            pristine_added: false,
        }
    },
    props: {
        instance: Object,
        siloData: Object,
        slide: Object,
        pauseVideo: Boolean,
        active: Boolean,
        isLast: Boolean,
    },
    computed: {
        formId() {
            return this.instance.panels_info.widget_id;
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.assign();
        });
    },
    watch: {
        siloData() {
            this.$nextTick(() => {
                this.assign();
            });
        }
    },
    destroyed(){
        //console.log('Form Destroyed!');
        this.inputs = null;
        this.pristine.destroy();
        this.pristine = null;
        this.pristine_added = false;
        this.is_valid = false;
    },
    methods: {
        // parse items inside quote as data from silodata
        parseText(text) {
            let replacedStr = text.replace(/%([^%]*)%/g, (match, p1) => this.renderReplacements(match, p1));
            return replacedStr;
        },
        renderReplacements(match, p1) {
            let replaced = p1;

            // NOTE: I might get rid of the option of not doing a multi-node selection because it's easier / faster

            // %stats.days_tracked%
            if (replaced.includes('.')) {
                let a = replaced.split('.');
                //console.log(a);
                let varCheck = this.siloData.user[a[0]][a[1]];
                if (varCheck !== undefined) {
                    replaced = varCheck;
                    return replaced;
                }
            // %meta_t2_q8_s%
            } else {
                let varCheck = this.siloData.user.modules[p1];
                if (varCheck !== undefined) {
                    replaced = varCheck;
                    // check if we're returning an array or a string
                    if (Array.isArray(replaced)) {

                        // If there are more than one item in the array create a list
                        if (replaced.length > 1) {
                            // return list with each array item
                            let list = `<ul>`;
                                replaced.forEach(item => { list+=`<li>${item}</li>`; });
                                list += `</ul>`;
                                return list;
                        // If there aren't enough for a list, just echo it (may not work in all cases)
                        } else {
                            return replaced[0];
                        }

                    } else {
                        // return string
                        return replaced;
                    }
                } else {
                    // return undefined string?
                    return replaced;
                }
            }

            return replaced;
        },
        // This is just to get rid of the default next styling
        filterNextButtonText(text) {
            let newText = text.replace('&gt;','');
            return newText;
        },
        assign() {
            // This only grabs required inputs
            this.inputs = this.$refs['parent'].querySelectorAll('[required]');
            //this.inputs_optional = this.$refs['parent'].querySelectorAll('[optional]');
            if (this.pristine_added === false) {
                this.pristine_added = true;
                this.pristine = new pristine(this.$refs['form'], this.validation_config, true);
                console.log('PRISTINE ADDED:', this.$refs['form']);
            } else {
                console.log('PRISTINE ALREADY EXISTS');
            }
            // The parent is mounted after all the children are mounted
            this.validate();
        },
        validate() {
            if (this.pristine === null) { return false; }
            this.inputs = this.$refs['parent'].querySelectorAll('[required]');
            this.is_valid = this.pristine.validate(this.inputs);

            //console.log('validating fierlds');
            // Check if there is a video in the form
            if (this.$refs.form.querySelector('.embed[data-is-valid="false"]')) {
                //console.log('found an invalid video');
                this.is_valid = false;
            }
            //console.log('form is valid:', this.is_valid);
        },
        // Validate fields without letting them know
        validateQuiet() {
            if (this.pristine === null) { return false; }
            this.inputs = this.$refs['parent'].querySelectorAll('[required]');
            this.is_valid = this.pristine.validate(this.inputs, true);
        },
        submit() {
            if (!this.is_valid) return;
            console.log('submitting panelform');

            if (this.$refs.parent.querySelector('.likert') !== null) {
                console.log('A likert has been found!');
                this.submitLikert();
                return; // stop whatever we are doing here
            }

            if (this.type === 'goals') {
                console.log('the type is GOALS');
                this.submitGoals();
                return;
            }

            if (this.type === 'checkin') {
                console.log('form: submit: this form is of the type CHECKIN')
                this.submitCheckin();
                return;
            }

            let data = [];

            // Loop through required items
            this.inputs.forEach(input => {
                // If it's not checked don't pass it up
                if (input.type === "radio" && input.checked == false) { return; }
                if (input.type === "checkbox" && input.checked == false) { return; }

                let key = input.dataset.pushKey;
                let value = input.value;

                // Don't allow passing up of blank data
                if (value === "") { return; }

                let data_item = {
                    key,
                    value
                }
                data.push(data_item);
            });

            if (this.type === 'decisions') {
                console.log('this type is DECISIONS');
                this.checkDecision(data);
            }

            //console.log("FORMS: DATA", data);

            // set processing
            this.$emit('processing', true);

            axios.post(this.siloData.urls.postuserdata, data).then(response => {
                console.log(response);
                // If we get it, tell the app to refresh the silo data
                // Then complete the form page and move to the next
                
                // Pass data object to post submit data event
                this.postSubmitData(data);
                
                // Turn off processing
                // this.$emit('processing', false);

                //let onComplete = this.$emit('next');
                //window.bonusloader.setNextOnRefresh();

                // Pass up the chain the idea to allow for next after data refresh
                console.log('EMITTING setNextOnRefresh FROM THE FORM');
                this.$emit('setNextOnRefresh');

                // When the data processing is complete, fire next
                this.$emit('refreshData');

                // If this is the last slide, close the lesson
                if (this.isLast === true) {
                    console.log('panel form: emitting tomenu');
                    this.$emit('toMenu');
                }

            }).catch(err => {
                console.log(err);
                // Turn off processing
                this.$emit('processing', false);
            });

        },
        submitCheckin() {
            console.log('form: checkin: submitting checkin');

            const data = {
                data: []
            };

            // some kind of parent variable
            const inputs = this.$refs.parent.querySelectorAll('.option input:checked');

            // some kind of foreach that adds data sets to the parent
            inputs.forEach(input => {
                let key = input.dataset.pushKey;
                let value = input.value;

                //if (value === "") { return; }

                let data_item = {
                    key, value
                }

                data.data.push(data_item);
            });

            console.log('form: submit checkin: data', data);

            // set processing
            this.$emit('processing', true);

            axios.post(this.siloData.urls.postcheckin, data).then(response => {
                console.log(response);

                // Pass data object to post submit data event
                this.postSubmitData(data);

                // Pass up the chain the idea to allow for next after data refresh
                this.$emit('setNextOnRefresh');

                // When the data processing is complete, fire next
                this.$emit('refreshData');

                // If this is the last slide, close the lesson or page
                if (this.isLast === true) {
                    console.log('panel form: emitting tomenu');
                    this.$emit('toMenu');
                }

            }).catch(err => {
                console.log(err);
                this.$emit('processing', false);
            });

        },
        submitGoals() {
            console.log('doing a submit goals');

            // Set up data object
            let data = {
                data: [], // Fill this later
            };

            // get parent
            const goal_inputs = this.$refs.parent.querySelectorAll('.goals__responses__response');
            // loop through each item in parent
            goal_inputs.forEach(input => {
                let data_item = {
                    question: input.querySelector('.question').value,
                    question_short: input.querySelector('.question_short').value,
                    answer: input.querySelector('.answer').value,
                }
                data.data.push(data_item);
            });

            // create an array with the question, the question short and their answer
            // add it to the array and then submit

            console.log(data);

            // set processing
            this.$emit('processing', true);

            axios.post(this.siloData.urls.postgoals, data).then(response => {
                console.log(response);

                this.postSubmitData(data);

                this.$emit('setNextOnRefresh');

                this.$emit('refreshData');

                // If this is the last slide, close the lesson
                if (this.isLast === true) {
                    this.$emit('toMenu');
                }

            }).catch(err => {
                console.log(err);
                this.$emit('processing', false);
            });
        },
        submitLikert() {
            console.log('doing a submit likert instead of a regular submit');

            // Set up data object
            let data = {
                key: this.inputs[0].dataset.pushKey, // Get push key from first input
                data: [], // Fill this later
            };

            // Loop through required items
            this.inputs.forEach(input => {
                // If it's not checked don't pass it up
                if (input.type === "radio" && input.checked == false) { return; }

                let labelValue = input.dataset.label;
                let ratingValue = input.value;

                // Don't allow passing up of blank data
                if (labelValue === "" || ratingValue === "") { return; }

                let data_item = {
                    label: labelValue,
                    rating: ratingValue,
                }
                data.data.push(data_item);
            });

            console.log(data);

            // set processing
            this.$emit('processing', true);

            axios.post(this.siloData.urls.postlikert, data).then(response => {
                console.log(response);
                // If we get it, tell the app to refresh the silo data
                // Then complete the form page and move to the next
                
                // Pass data object to post submit data event
                this.postSubmitData(data);

                // WE NEED A FLAG TO DETERMINE IF IT'S THE LAST PAGE
                
                // Turn off processing
                // this.$emit('processing', false);
                //let onComplete = this.$emit('next');
                //let onComplete = console.log('test');

                // Pass up the chain the idea to allow for next on refresh data
                this.$emit('setNextOnRefresh');
                // When the data processing is complete, fire next
                this.$emit('refreshData', onComplete);
            }).catch(err => {
                console.log(err);
                // Turn off processing
                this.$emit('processing', false);
            });
        },
        // Run a check to see if the data we are submitting is the same as what is already there
        // If it isn't clear the second field we grabbed
        checkDecision(data) {
            // Flatten new data so it matches the silo data
            let newData = data.map(item => item.value);

            let existingData = this.siloData.user.modules[this.instance.check_push_key];

            // If we don't have silo data, don't bother with this
            if (existingData === "" || existingData === null) { return; }

            // Check if these are the same by validating them as strings
            if (newData.join() === existingData.join()) {
                console.log(newData.join());
                console.log(existingData.join());
                console.log('DECISION DATA IS THE SAME');
            } else {
                console.log(newData.join());
                console.log(existingData.join());
                console.log('DECISION DATA HAS CHANGED');

                let clearData = [
                    {
                        key: this.instance.check_clear_key,
                        value: "%clear%"
                    }
                ]

                // Since the data has changed, we need to clear out the
                axios.post(this.siloData.urls.postuserdata, clearData);
            }

        },
        // Pass a key and an array to remove duplicates
        removeDuplicates(arr, key) {
            var values = {};
            return arr.filter(function (item) {
                var val = item[key];
                var exists = values[val];
                values[val] = true;
                return !exists;
            });
        },
        // Send data to the event tracker to post to a custom event
        async postSubmitData(formData, onComplete) {
            if (window.events === undefined ) { return; }
            console.log('POSTING SUBMIT DATA');
            let data = {
                type: 'submit',
                data: formData,
            };
            const response = await window.events.postSubmitData(data);
            console.log('RESPONSE', response);
        },
        /****** Video Specific Methods */
        // Emitted when playing a video
        playingVideo() {
            //console.log('setting playing video to false!');
            //this.pauseVideo = false;
            this.$emit('playingVideo');
        },
    }, 
}
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.form-panel {
    transition: all 0.15s;
}
[data-processing="true"] {
    .form-panel {
        opacity:0.25;
        button {
            pointer-events: none;
        }
        input {
            pointer-events: none;
        }
    }
}
.form {
    margin-top: rem(8px) !important;
    label.type--h3 {
        margin-top: rem(20px);
        margin-bottom: 0 !important;
    }
}
.button-enter, .button-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
.input--error {

}
// Just hiding the input errors for now
.pristine-error.input__help {
    display: none;
    position: absolute;
    margin-top: 0 !important;
}
</style>